import apiFactory from '../utils/api-factory'
import logUtil from '../utils/log-util'

const logger = logUtil

export async function loadUserPreferences() {
  try {
    logger.log('Getting user preferences')
    const response = await apiFactory.getUserPreferences()
    logger.log('Getting user preferences completed')
    return response
  } catch (error) {
    logger.error('Error getting user preferences:', error)
    throw error
  }
}

//fetch live payload for upgradeHub user
export async function getLivePayloadData(csrf, payload) {
  try {
    logger.log('Getting live payload')
    const response = await apiFactory.getLivePayloadData(csrf, payload)
    logger.log('Getting live payload completed')
    return response
  } catch (error) {
    logger.error('Error getting live payload:', error)
    throw error
  }
}
